import type { NavigationGuard } from "vue-router";
import { useSessionLogic } from "@shared/use/useSessionLogic.ts";
import { RouteNames } from "@shared/types/localTypes/router.ts";
import { useKeycloakStore } from "@shared/stores/keycloak.ts";
import { isRunningOnTour } from "@shared/utils/tour.ts";

export const checkActiveSession: NavigationGuard = async () => {
  if (useSessionLogic().isSessionActive()) {
    return { name: RouteNames.Root };
  }

  if (isRunningOnTour()) {
    return;
  }

  const keycloakStore = useKeycloakStore();
  await keycloakStore.initializeKeycloak();

  if (keycloakStore.keycloak?.authenticated) {
    return { name: RouteNames.Root };
  }
};
